import { IAction } from "../model/IAction";

import { HashMap } from "../../shared/model/HashMap";
import { ThunkResult } from "../../shared/utilities";
import { State } from "../model/State";
import { rebuildVariableScopesAndTriggerValidationAction } from "./ValidateProcess";

export const SELECT_CONDITIONAL_PROCESS = "SELECT_CONDITIONAL_PROCESS";

export function selectConditionalProcess(
    elementId: string, selectedProcessGuid: string, skipValidation?: boolean)
    : ThunkResult<void, State> {
    return (dispatch, getState) => {
        const state = getState();

        const subprocessData = state.subProcesses.find((s) => s.uniqueIdentifier === selectedProcessGuid);
        const subprocessConfig = state.elements[elementId].parameters;
        const subprocessParameters = subprocessConfig && subprocessConfig.parameters;

        const defaultParameters: HashMap<string | undefined> = {};
        if (subprocessData && subprocessData.manualTriggerParameters) {
            for (const parameter of subprocessData.manualTriggerParameters) {
                const currentParameterValue = subprocessParameters ? subprocessParameters[parameter.name] : null;
                defaultParameters[parameter.name] = currentParameterValue || parameter.nonStringifiedDefaultValue;
            }
        }

        dispatch<SelectConditionalProcessAction>({
            type: SELECT_CONDITIONAL_PROCESS,
            elementId: elementId,
            selectedProcessGuid: selectedProcessGuid,
            defaultParameters: defaultParameters
        });
        if (!skipValidation) {
            dispatch(rebuildVariableScopesAndTriggerValidationAction());
        }
    };
}
export interface SelectConditionalProcessAction extends IAction {
    elementId: string;
    selectedProcessGuid: string;
    defaultParameters: any;
}
